import React from 'react';
import { Monitor, Tablet, Smartphone } from 'lucide-react';
import { useFunnelStore } from '../../store/funnelStore';
import { Breakpoint } from '../../types/element.types';

/**
 * Viewport Switcher Component
 * Allows switching between different device breakpoints
 */
const ViewportSwitcher: React.FC = () => {
  const { currentBreakpoint, setBreakpoint } = useFunnelStore();

  const viewports: Array<{ breakpoint: Breakpoint; icon: React.ReactNode; label: string }> = [
    { breakpoint: 'desktop', icon: <Monitor size={16} />, label: 'Desktop' },
    { breakpoint: 'tablet', icon: <Tablet size={16} />, label: 'Tablet' },
    { breakpoint: 'mobile', icon: <Smartphone size={16} />, label: 'Mobile' },
  ];

  return (
    <div className="flex items-center gap-1 bg-gray-100 rounded-[7px] p-1">
      {viewports.map((viewport) => (
        <button
          key={viewport.breakpoint}
          onClick={() => setBreakpoint(viewport.breakpoint)}
          className={`
            flex items-center gap-1.5 px-3 py-1.5 rounded-[7px] text-sm font-medium transition-all
            ${
              currentBreakpoint === viewport.breakpoint
                ? 'bg-white text-[#003C07] shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }
          `}
          title={viewport.label}
        >
          {viewport.icon}
          <span className="hidden sm:inline">{viewport.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ViewportSwitcher;

